namespace TabAurous {
    export interface PartyRequest extends Serenity.ListRequest {
        LedgerIds?: number[];
        PartyCode?: string;
        LedgerId?: number;
        AccountGroupId?: number;
    }
}
